/* global jQuery COMPONENTS */

COMPONENTS.ComponentAccordion = (function ($) {
  function ComponentAccordion () {
    this.$component = $('[data-ecs-component="component-accordion"]')
    this.$accordions = this.$component.find('[data-ecs-components-control="accordion"]')
    this.$categoryLinks = this.$component.find('[data-ecs-accordion-category-link]')
    this.$categoryButtons = this.$component.find('[data-ecs-accordion-category-control]')
    this.$accordionButtons = this.$component.find('[data-ecs-accordion-control-button]')
    this.$accordionCategories = this.$component.find('[data-ecs-accordion-category]')
    this.$accordionSlider = this.$component.find('[data-ecs-components-control="accordion-slider"]')
    // this.$accordionIsotope = this.$component.find('[data-ecs-accordion-isotope-container]')
    this.utility = new COMPONENTS.Utility()
  }

  ComponentAccordion.prototype.openCategory = function (categorySearch) {
    const component = this
    const selectedCategory = categorySearch || '*'
    const $allCategoryButton = component.$categoryButtons.filter('[data-ecs-accordion-category-control="*"]')

    component.$categoryButtons.removeClass('ecs_active')
    component.$categoryButtons.filter('[data-ecs-accordion-category-control="' + selectedCategory + '"]').addClass('ecs_active')

    if (selectedCategory === '*' && $allCategoryButton.length) {
      $allCategoryButton.addClass('ecs_active')
      component.$accordionCategories.show()
      return
    }

    component.$accordionCategories.each(function () {
      const $category = $(this)
      const isSelected = $category.data('ecs-accordion-category') === selectedCategory

      $category.toggle(isSelected)

      if (isSelected) {
        $category.accordion('close', 'others')
        $category.accordion('open', 0)
      }
    })
  }

  ComponentAccordion.prototype.init = function () {
    const component = this
    let accordion_index = 0

    if (component.$accordions.length < 1) {
      // no accordion on page
      return false
    }
    component.$accordions.accordion()

    if (component.$accordionSlider.length >= 1) {
      const sliderVars = component.utility.getSliderVars(1, false, true, true, false, false)
      component.$accordionSlider.slick(sliderVars)
      component.utility.bindSliderAriaSelected(component.$accordionSlider)

      component.$accordionSlider.on('afterChange', function(event, slick, currentSlide, nextSlide) {
        component.$accordions.accordion('open', currentSlide)
      })
    }

    // Initialize Isotope if container exists
    // if (component.$accordionIsotope.length >= 1) {
    //   const category = component.$categoryButtons.first().data('ecs-accordion-category-control')
    //   console.log('Initializing Isotope with category:', category)
    //   component.openCategory(category)
    // }

    component.$accordionButtons.each(function() {
      $(this).attr('data-ecs-accordion-index', accordion_index)
      accordion_index++
    })

    component.$accordionButtons.click(function() {
      if (component.$accordionSlider.length >= 1) {
        component.$accordionSlider.slick('slickGoTo', $(this).data('ecs-accordion-index'))
      }

      // if (component.$accordionIsotope.length >= 1) {
      //   setTimeout(function() {
      //     component.$accordionIsotope.isotope()
      //   }.bind(this), 500)
      // }
    })

    component.$accordionCategories.each(function() {
      const $firstButtonIndex = $(this).find('[data-ecs-accordion-control-button]').first().attr('data-ecs-accordion-index')
      $(this).attr('data-ecs-accordion-first-drawer-index', $firstButtonIndex)
    })

    if (component.$categoryButtons.length >= 1) {
      const initialCategory = component.$categoryButtons.filter('.ecs_active').first().data('ecs-accordion-category-control') || component.$categoryButtons.first().data('ecs-accordion-category-control')
      component.openCategory(initialCategory)
    }

    component.$categoryLinks.click(function () {
      const category = $(this).data('ecs-accordion-category-link')
      const $targetAccordion = component.$accordions.filter('[data-ecs-accordion-category="' + category + '"]')
      $targetAccordion.accordion('open', 0)

      $('.ecs__components__accordion__content__wrapper').removeClass('active')
      component.$accordions.each(function () {
        $(this).accordion('close', 'others')
      })

      if (component.$accordionSlider.length >= 1) {
        component.$accordionSlider.slick('slickGoTo', $(this).data('accordion-index'))
      }
    })

    component.$categoryButtons.click(function () {
      const category = $(this).data('ecs-accordion-category-control')
      component.openCategory(category)
    })
  }

  return ComponentAccordion
})(jQuery)

document.addEventListener('components_init', function (e) {
  // Hook into the main components init
  COMPONENTS.componentAccordion = new COMPONENTS.ComponentAccordion()
  COMPONENTS.componentAccordion.init()
})
